import * as z from 'zod';

import { jobPositionQuerySchema } from './job-position-query-schema';

export const jobPositionUpdateSchema = jobPositionQuerySchema
  .pick({
    id: true,
    name: true,
    preferred_location_id: true,
    preferred_relationship_id: true,
    salary_grade_id: true,
    department_id: true,
    business_discipline_id: true,

    result_statement: true,
    strategic_work: true,
    tactical_work: true,
    standards_work: true,

    need_to_succeed: true,
    expectations: true,
    position_overview: true,
    applicant_questions: true,
    interview_questions: true,
  })
  .extend({
    status: z.string(),
  });

export type JobPositionUpdateSchema = z.infer<typeof jobPositionUpdateSchema>;

export const jobPositionCreateSchema = jobPositionUpdateSchema.omit({
  id: true,
});

export type JobPositionCreateSchema = z.infer<typeof jobPositionCreateSchema>;
